module.exports = __webpack_public_path__ + "img/banner.5dfce44e.jpg";